import { createRoot } from "react-dom/client";
import { Provider } from "react-redux";
import { Security } from "@okta/okta-react";
import OktaAuth from "@okta/okta-auth-js";

import { store } from "./app/store";
import { Notifications } from "./app/notifications";
import { handleAuthError, oktaAuth } from "./app/auth/authUtils";
import App from "./App.tsx";
import "./index.css";

createRoot(document.getElementById("root")!).render(
  <Security
    oktaAuth={oktaAuth}
    onAuthRequired={handleAuthError}
    restoreOriginalUri={function (
      oktaAuth: OktaAuth,
      originalUri: string
    ): void | Promise<void> {
      throw new Error("Function not implemented.");
    }}
  >
    <Provider store={store}>
      <Notifications>
        <App />
      </Notifications>
    </Provider>
  </Security>
);
